import React from 'react';
import LocalModal from 'components/base/local-modal';
import { ReactComponent as MailIcon } from 'assets/icons/mail-icon.svg';
import { ReactComponent as WhatsappIcon } from 'assets/icons/whatsapp-icon.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/phone-icon.svg';
import { ArrowRightIcon } from 'cokitchen-icons';
import './style.scss';

type ContactDetailsProps = {
  show: boolean;
  onClose: () => void;
};
const ContactSupport = ({ show, onClose }: ContactDetailsProps) => {
  const contactInfo = [
    {
      icon: <MailIcon />,
      title: 'Email us',
      describtion: 'Replies within 8hrs',
      link: 'mailto:hello@getfoodcourt.com'
    },
    {
      icon: <WhatsappIcon />,
      title: 'Chat on WhatsApp',
      describtion: 'Replies ASAP',
      link: 'https://wa.me/+23418888577/?text=In-app support needed'
    },
    {
      icon: <PhoneIcon />,
      title: 'Call us',
      describtion: 'Business hours everyday',
      link: 'tel:+23418888577'
    }
  ];
  return (
    <LocalModal isOpen={show} onRequestClose={onClose} title='Contact support'>
      <div className=''>
        <p className='text-[#6F7376] text-xs text-center'>Got a problem? Let’s fix it.</p>
        <div className='flex flex-col gap-4 mt-4'>
          {contactInfo.map((item, index) => (
            <div key={index} className='flex items-center justify-between'>
              <a href={item.link} target='_blank' rel='noopener noreferrer' className='flex gap-3'>
                <div className='w-10 h-10 rounded-full bg-[#F7F7F7] flex items-center justify-center'>
                  {item.icon}
                </div>
                <div>
                  <p className='text-sm '>{item.title}</p>
                  <p className='text-xs text-[#6F7376] mt-1'>{item.describtion}</p>
                </div>
              </a>
              <a href={item.link} target='_blank' rel='noopener noreferrer'>
                <ArrowRightIcon color='#6F7376' className='w-6 h-7 cursor-pointer' />
              </a>
            </div>
          ))}
        </div>
      </div>
    </LocalModal>
  );
};

export default ContactSupport;
